import { defineStore } from "pinia";
import { readStored, writeStored } from "@/utils/safeStorage";

const OFFLINE_MODE_KEY = "atmo-offline-mode";
const OFFLINE_MISSION_KEY = "atmo-offline-mission";
const LAST_SERVER_REACH_KEY = "atmo-last-server-reach";
const SERVER_REACH_REFRESH_MS = 30 * 1000;

export const useNetworkStore = defineStore("network", {
  state: () => ({
    isOnline: window.navigator.onLine,
    isOfflineMode: readStored(OFFLINE_MODE_KEY) === "true",
    offlineMissionUuid: readStored(OFFLINE_MISSION_KEY) || null,
    lastServerReachAt: Number(readStored(LAST_SERVER_REACH_KEY)) || null,
    isPreloadOpen: false,
  }),
  actions: {
    setOnline(isOnline) {
      this.isOnline = isOnline;
    },
    setOfflineMode(isOfflineMode, missionUuid = null) {
      this.isOfflineMode = isOfflineMode;
      this.offlineMissionUuid = isOfflineMode ? missionUuid : null;
      writeStored(OFFLINE_MISSION_KEY, this.offlineMissionUuid ?? "");
      writeStored(OFFLINE_MODE_KEY, String(isOfflineMode));
    },
    setPreloadOpen(isPreloadOpen) {
      this.isPreloadOpen = isPreloadOpen;
    },
    markServerReached() {
      const now = Date.now();
      if (now - (this.lastServerReachAt ?? 0) < SERVER_REACH_REFRESH_MS) return;
      this.lastServerReachAt = now;
      writeStored(LAST_SERVER_REACH_KEY, String(now));
    },
    followOtherTab({ key, newValue }) {
      if (key === OFFLINE_MODE_KEY) this.isOfflineMode = newValue === "true";
      if (key === OFFLINE_MISSION_KEY)
        this.offlineMissionUuid = newValue || null;
      if (key === LAST_SERVER_REACH_KEY)
        this.lastServerReachAt = Number(newValue) || null;
    },
    listen() {
      window.addEventListener("online", () => this.setOnline(true));
      window.addEventListener("offline", () => this.setOnline(false));
    },
  },
});
